import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface VerificationRequest {
  code: string;
}

export default (makeCall: MakeCall) =>
  (userId: number, { code }: VerificationRequest) =>
    makeCall('POST', `${APIV2_URL}/user/${userId}/verify-code`, {
      data: {
        code,
      },
    });
